import { mapState } from 'vuex';
import globalConfig from '@utiles/globalConfig';
import iframeMessage from '@mixins/officialSupport/iframeMessage';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
import {
  SET_IS_SPECIAL_DIFY_USER,
  SET_SHOW_UPDATE_VERSION_POPUP
} from '@store/officialSupport';
const mainHost = globalConfig.getMainHost();
export const aiBotAppId = {
  // 191: 'lNPQL34zrvdW05sO',
  // 284: 'lNPQL34zrvdW05sO',
  // 227: 'lNPQL34zrvdW05sO',
  // 225: 'lNPQL34zrvdW05sO',
  // 221: 'lNPQL34zrvdW05sO',
  common: 'DIuBgxrObMngUrYy'
};
export default {
  mixins: [iframeMessage],
  data() {
    return {
      gameId:
        globalConfig.getHrefParam('gameId') ||
        globalConfig.getHrefParam('gameID') ||
        globalConfig.getHrefParam('game_id') ||
        ''
    };
  },
  computed: {
    ...mapState({
      curLang: state => state.curLang,
      isLogin: state => state.isLogin,
      isJumpAiBot: state => state.isJumpAiBot
    }),
    aiBotLink() {
      return `https://gsupport.${mainHost}/smartChat/aibot?gameId=${this.gameId}&serverId=${
        globalConfig.getHrefParam('serverId') || ''
      }&roleId=${globalConfig.getHrefParam('roleId') || ''}&roleName=${
        globalConfig.getHrefParam('roleName') || ''
      }&language=${this.curLang}`;
    }
  },
  methods: {
    getSystemInfo() {
      if (this.getDevice().isAndroid() || this.getDevice().isWinPhone()) {
        return 'android';
      }
      if (this.getDevice().isIOS() || this.getDevice().isIpad()) {
        return 'ios';
      }
      return 'pc';
    },
    getDevice() {
      let userAgent = window.navigator.userAgent;
      let ua = userAgent.toLowerCase();
      return {
        isAndroid: function () {
          return ua.indexOf('android') > -1;
        },
        isIOS: function () {
          let NPlatform = navigator?.platform;
          return (
            ua.indexOf('iphone') > -1 ||
            /iPad|iPhone|iPod/gi.test(NPlatform) ||
            (NPlatform === 'MacIntel' &&
              navigator.maxTouchPoints > 1 &&
              !window.MSStream)
          );
        },
        isWinPhone: function () {
          return !!navigator.userAgent.match(/Windows Phone/i);
        },
        isIpad: function () {
          return ua.indexOf('ipad') > -1;
        },
        isPhone: function () {
          return (
            this.isAndroid() ||
            this.isIOS() ||
            this.isWinPhone() ||
            this.isIpad()
          );
        }
      };
    },
    getiOSVersion() {
      const ua = navigator.userAgent;
      const match = ua?.match(/OS ([\d_]+) like Mac OS X/);
      if (!match) return null; // 非iOS设备
      return match?.[1]?.split('_')?.map((num) => parseInt(num))?.[0] || null;
    },
    showUpgradeVersionPopup() {
      // 一个自然天触发一次
      const lastTime = localStorage?.getItem('specialDifyUserLastTime');
      if (lastTime) {
        const now = new Date();
        const lastDate = new Date(lastTime);
        const diffTime = now - lastDate;
        if (diffTime < 24 * 60 * 60 * 1000) {
          return;
        }
      }
      localStorage?.setItem(
        'specialDifyUserLastTime',
        new Date().toISOString()
      );
      this.$store.commit(SET_SHOW_UPDATE_VERSION_POPUP, true);
    },
    goAiBot() {
      // 如果为ios17以下，则跳转到goCreateCommerOrder
      const iosVersion = this.getiOSVersion();
      if (this.getSystemInfo() == 'ios' && iosVersion && +iosVersion < 17) {
        this.$store.commit(SET_IS_SPECIAL_DIFY_USER, 1);
        this.showUpgradeVersionPopup();
        setTimeout(() => {
          this.goCreateCommerOrder();
        }, 500);
        return;
      }
      const inWebOfficialSupport =
        globalConfig.getHrefParam('inWebOfficialSupport') == 1;
      if (inWebOfficialSupport) {
        this.postMessageToParent(
          'locationLink',
          getGlobalGetGotoLink({ link: this.aiBotLink })
        );
        return;
      }
      this.$store.commit(SET_IS_SPECIAL_DIFY_USER, 0);
      window.location.href = getGlobalGetGotoLink({ link: this.aiBotLink });
    },
    goCreateCommerOrder(source) {
      this.$router.push({
        path: '/creatework',
        query: {
          source: source || ''
        }
      });
    },
    handleContactService(contactSource) {
      if (
        this.isLogin &&
        this.isJumpAiBot &&
        !globalConfig.isTiktokMiniProgram()
      ) {
        this.goAiBot();
      } else {
        this.$store.commit(SET_IS_SPECIAL_DIFY_USER, 0);
        this.goCreateCommerOrder(contactSource);
      }
    }
  }
};
